<template>
    <div>
        <cart v-if="stepId === cartStepId">
            <template v-slot:prev-btn>
                <button class="calc-btn prev" v-if="prevStepIndex" @click="stepToggle('prev')">&#8592; Назад</button>
            </template>
        </cart>


        <template v-if="stepId === cartStepId">

        </template>
        <template v-else>
            <button class="calc-btn prev" v-if="prevStepIndex" @click="stepToggle('prev')">&#8592; {{textPrev}}</button>
            <button class="calc-btn next" v-if="nextStepIndex" @click="stepToggle('next')">{{textNext}} &#8594;</button>
        </template>
    </div>
</template>

<script>
    import Cart from './Cart';
    export default {
        data : function(){
          return  {
              textNext : this.$text.buttons.next,
              textPrev : this.$text.buttons.prev,
          }
        },
        components : {
          Cart
        },
        props : ['stepId', 'prevStepIndex', 'nextStepIndex', 'activeStepIndex', 'cartStepId'],
        computed : {
            unvalidateCriteria : function () {
                return this.$store.getters.getUnvalidateCriteria
            }
        },
        methods : {
            stepToggle(direction){
                if(direction === 'next'){
                    //validate step criterion values
                    if(this.unvalidateCriteria().length){
                        this.$store.commit('setStepValidClass', 'step-has-errors');

                    }else{
                        this.$store.commit('setActiveStepByIndex',this.activeStepIndex+1);
                        this.$store.commit('setStepValidClass', 'valid');
                        if(window.innerWidth < 768) {
                            document.querySelector('.step-panel').scrollIntoView({alignToTop: 1, behavior: 'smooth'})
                        }
                    }
                }else{
                    this.$store.commit('setActiveStepByIndex',this.activeStepIndex-1)
                    if(window.innerWidth < 768) {
                        document.querySelector('.step-panel').scrollIntoView({alignToTop: 1, behavior: 'smooth'})
                    }
                }

            },
        }
    }
</script>
